const DEFAULT_SCROLL_CONTAINER_ID = 'scroll-container';

type UseResetScrollOptions = {
  scrollContainerId?: string;
  smooth?: boolean;
};

/**
 * Resets the scroll position to 0,0 for the scroll container given. Default scroll container id is `scroll-container`
 */
// eslint-disable-next-line react-x/no-unnecessary-use-prefix -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
export const useResetScroll = (options?: UseResetScrollOptions) => {
  // eslint-disable-next-line react-x/purity -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
  const scrollContainer = document.getElementById(
    options?.scrollContainerId || DEFAULT_SCROLL_CONTAINER_ID,
  );

  const resetScroll = () =>
    scrollContainer?.scrollTo({
      top: 0,
      behavior: options?.smooth ? 'smooth' : 'auto',
    });

  return resetScroll;
};
